import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { AnnouncementModel } from './models/announcement.model';

export interface AnnouncementState extends EntityState<AnnouncementModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'announcement', cache: { ttl: 60000 }, idKey: 'Id' })
export class AnnouncementStore extends EntityStore<AnnouncementState> {
  constructor() {
    super();
  }
}
